// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3Ik7Z","head":"ProcedureTableInfo_head__1zRYb"};